import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuienesSomosComponent } from './page/quienes-somos/quienes-somos.component';
import { FacturacionComponent } from './page/facturacion/facturacion.component';
import { PolizasJuridasComponent } from './page/polizas-juridas/polizas-juridas.component';
import { ContactoComponent } from './page/contacto/contacto.component';
import { BloqueoComponent } from "./page/bloqueo.component";
import { ModulosRoutingModule } from './modulos-routing.module';
import { MaterialModule } from '../material/material.module';
import { FormularioComponent } from './page/facturacion/formulario/formulario.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    QuienesSomosComponent,
    FacturacionComponent,
    PolizasJuridasComponent,
    ContactoComponent,
    BloqueoComponent,
    FormularioComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ModulosRoutingModule,
    ReactiveFormsModule
  ]
})
export class ModulosModule { }
